import { Clock, Trash2 } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import type React from "react";
import { View, XStack } from "tamagui";
import { getDayJs } from "../../../core/dayJs";
import { Block } from "../../../ui/Block";
import { Body } from "../../../ui/Body";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import { UserAvatar } from "../../../ui/UserAvatar";
import type SettlementItemModule from "../data/SettlementItemModule";
import type ExpenseModuleModel from "../ExpenseModuleModel";

export const SettlementRow: React.FC<{
  module: ExpenseModuleModel;
  settlement: SettlementItemModule;
}> = observer(({ module, settlement }) => {
  const debtorUserDisplayName =
    settlement.debtorUser?.data.displayName ?? "Unknown";
  const creditorUserDisplayName =
    settlement.creditorUser?.data.displayName ?? "Unknown";

  return (
    <Block
      infoRowItems={[
        {
          text: getDayJs(settlement.data.timestamp),
          icon: Clock,
        },
      ]}
      grouped
      icon={<UserAvatar userUid={settlement.debtorUser?.uid} />}
    >
      <XStack width="100%" alignItems="center" gap={"$larger"}>
        <View flex={1} flexBasis={0}>
          <Body>
            {settlement.debtorUser?.data.displayName} paid{" "}
            <Body color={"#059f04"}>
              {module.currencyFormatter.format(settlement.data.amountPaid)}
            </Body>{" "}
            to {settlement.creditorUser?.data.displayName}
          </Body>
        </View>
        <PopoverConfirm
          onConfirm={() => {
            settlement.deleteData(
              `settlement from ${debtorUserDisplayName} → ${creditorUserDisplayName} (${module.currencyFormatter.format(
                settlement.data.amountPaid,
              )})`,
            );
          }}
        >
          <Trash2 size={"$size.normal"} color={"$muted"} />
        </PopoverConfirm>
      </XStack>
    </Block>
  );
});
